__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "skillsstandardswebapp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common", "12.0.0", () => (Promise.all([__webpack_require__.e(8846), __webpack_require__.e(8583)]).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/common/__ivy_ngcc__/fesm2015/common.js */ 8583))))));
			register("@angular/core", "12.0.0", () => (Promise.all([__webpack_require__.e(7553), __webpack_require__.e(7716)]).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/core/__ivy_ngcc__/fesm2015/core.js */ 7716))))));
			register("@angular/router", "12.0.0", () => (Promise.all([__webpack_require__.e(7553), __webpack_require__.e(8846), __webpack_require__.e(6146), __webpack_require__.e(9895)]).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/router/__ivy_ngcc__/fesm2015/router.js */ 9895))))));
			register("@lst/lst-auth", "2.0.6", () => (Promise.all([__webpack_require__.e(7553), __webpack_require__.e(8846), __webpack_require__.e(6146), __webpack_require__.e(4358), __webpack_require__.e(364)]).then(() => (() => (__webpack_require__(/*! ./node_modules/@lst/lst-auth/__ivy_ngcc__/fesm2015/lst-lst-auth.js */ 364))))));
			register("@ngx-translate/core", "13.0.0", () => (__webpack_require__.e(9790).then(() => (() => (__webpack_require__(/*! ./node_modules/@ngx-translate/core/__ivy_ngcc__/fesm2015/ngx-translate-core.js */ 9790))))));
			register("apollo-angular", "1.10.0", () => (__webpack_require__.e(550).then(() => (() => (__webpack_require__(/*! ./node_modules/apollo-angular/__ivy_ngcc__/fesm2015/ngApollo.js */ 550))))));
			register("apollo-client", "2.6.10", () => (Promise.all([__webpack_require__.e(2716), __webpack_require__.e(1667)]).then(() => (() => (__webpack_require__(/*! ./node_modules/apollo-client/bundle.esm.js */ 1667))))));
			register("rxjs/operators", "6.6.7", () => (Promise.all([__webpack_require__.e(5967), __webpack_require__.e(397)]).then(() => (() => (__webpack_require__(/*! ./node_modules/rxjs/_esm2015/operators/index.js */ 397))))));
			register("rxjs", "6.6.7", () => (Promise.all([__webpack_require__.e(5967), __webpack_require__.e(765)]).then(() => (() => (__webpack_require__(/*! ./node_modules/rxjs/_esm2015/index.js */ 765))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};